import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '5',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Segments',
    colSize: '27',
    active: false,
    col: 'name',
  },
];
